import classNames from 'clsx';
import React, { memo, useEffect } from 'react';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Kind } from 'reactApp/types/Tree';
import { Button } from 'reactApp/ui/Button/Button';
import { FileIcon } from 'reactApp/ui/FileIcon/FileIcon';
import { getIconType } from 'reactApp/ui/FileIcon/getIconType';
import { NameComponent } from 'reactApp/ui/Name/Name';
import { noop } from 'reactApp/utils/helpers';

import { IViewerDwhData } from '../ReactViewer.helpers';
import styles from './Stub.css';

interface Props {
    ext?: string;
    kind: Kind;
    isVirus: boolean;
    name?: string;
    onClick?(): void;
    showName?: boolean;
    mode?: 'light' | 'dark';
    size?: 'small' | 'medium' | 'big';
    isDownloadable?: boolean;
    itemSize?: number | string;
    sendRadar?: (data: IViewerDwhData) => void;
    isFolder?: boolean;
}

export const Stub = memo(function Stub({
    ext,
    kind,
    isVirus,
    name,
    onClick = noop,
    showName = true,
    mode = 'light',
    size = 'medium',
    isDownloadable,
    itemSize,
    sendRadar,
    isFolder,
}: Props): JSX.Element | null {
    const iconType = getIconType({ isFolder, ext, kind, isVirus });

    useEffect(() => {
        sendRadar?.({ action: 'open-content-preview-error', forceSend: true });
    }, []);

    return (
        <div
            className={classNames({ [styles.root]: true, [styles[`root_${size}`]]: true, [styles.cursor_default]: isDownloadable })}
            onClick={IS_ONPREMISE ? noop : onClick}
        >
            <div className={styles.content}>
                <FileIcon type={iconType} view={EViewMode.thumbs} mode={mode} />
            </div>
            {showName && name && (
                <div className={styles.footer}>
                    <div className={styles.meta}>
                        <div className={styles.name}>
                            <NameComponent name={name} extension={ext} showTooltip />
                        </div>
                        {isDownloadable && (
                            <Button className={styles.download_btn} onClick={onClick} size="big" theme="base" middle secondary>
                                Скачать {IS_ONPREMISE && itemSize}
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
});
